import { createContext, use } from 'react'

import type { AlertReport } from '../lib/alert-rules-api.ts'

/** The catalogue entry for this path, and the one sheet the button and search share. */
export interface PageAlertValue {
  reports: readonly AlertReport[]
  /** True after a successful load, including an empty catalogue. */
  catalogueLoaded: boolean
  report: AlertReport | null
  open: boolean
  setOpen: (open: boolean) => void
  /** Opens the sheet. Search and the button both call this. */
  openAlert: () => void
  /** Opens the destination report after the router reaches its path. */
  openAlertOn: (path: string) => void
}

/** Shared alert state; the provider owns the sheet lifetime. */
export const PageAlertContext = createContext<PageAlertValue | null>(null)

/** Read optional alert support when search runs outside the console layout. */
export function useSearchAlerts(): PageAlertValue | null {
  return use(PageAlertContext)
}

/**
 * Read the alert for the page on screen.
 *
 * @returns The catalogue entry and the shared sheet.
 * @throws When called outside a `PageAlertProvider`.
 */
export function usePageAlert(): PageAlertValue {
  const value = use(PageAlertContext)
  if (!value) {
    throw new Error('usePageAlert must be called inside a PageAlertProvider')
  }

  return value
}
